var _a;
import { __assign } from "tslib";
import { makeStyles, shorthands } from '@fluentui/react-components';
import { EasyEaseAnimation, mediaQuery } from './Constants';
export var useFirstRunGreetingsStyles = makeStyles({
    container: __assign(__assign({ boxSizing: 'border-box', display: 'none', flexDirection: 'column', alignItems: 'center', position: 'absolute', width: '100%' }, shorthands.padding('0', '24px')), { opacity: '0', transitionDuration: '300ms', transitionProperty: 'all', msTransitionTimingFunction: EasyEaseAnimation }),
    containerActive: {
        opacity: '1',
        display: 'flex',
    },
    iconContainer: {
        marginBottom: '24px',
    },
    textWrapper: {
        position: 'relative',
    },
    textContainer: (_a = {
            opacity: '0',
            position: 'absolute',
            top: '0',
            height: '100%',
            width: '100%',
            display: 'grid',
            alignItems: 'center',
            justifyContent: 'center',
            transitionDuration: '300ms',
            transitionProperty: 'all',
            msTransitionTimingFunction: EasyEaseAnimation,
            transform: 'translateY(92px)'
        },
        _a[mediaQuery.minLarge] = {
            fontSize: '32px',
            lineHeight: '40px',
        },
        _a[':first-child'] = {
            position: 'static',
            transform: 'translateY(0px)',
        },
        _a['> p'] = __assign(__assign(__assign(__assign({}, shorthands.overflow('hidden')), { textOverflow: 'ellipsis', fontWeight: '600', fontSize: '28px', lineHeight: '36px' }), shorthands.margin('0')), { textAlign: 'center' }),
        _a),
    textContainerActive: {
        opacity: '1',
        transform: 'translateY(0px)',
    },
});
//# sourceMappingURL=FirstRunGreetings.styles.js.map